import React, {useEffect, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {LoadingData} from '../../../../../components/LoadingData'
import {useLocation} from 'react-router'
import {shouldDisplayFonctionnalite, toGmapQuery} from '../../../../../components/helpers'
import {useAuth} from '../../../../modules/auth'
import {getClientSource} from '../../../../../components/requests'
import {ModeleClientSource, modeleClientSourceInitValues} from '../../../../../components/Models'
import {KTIcon} from '../../../../../_metronic/helpers'

const ClientSourcesShowPage = () => {
  const location = useLocation()
  let {clientId} = useParams()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<ModeleClientSource>(modeleClientSourceInitValues)
  const navigate = useNavigate()
  const {currentUser} = useAuth()

  useEffect(() => {
    getClientData()
  }, [clientId])

  const getClientData = () => {
    getClientSource(clientId).then((clientRequest) => {
      if (clientRequest?.status === 200) {
        if (clientRequest?.data !== undefined) {
          setData(clientRequest?.data)
        }
        setLoading(false)
      } else {
        navigate(`/vente/client-sources/liste`)
      }
    })
  }

  return (
    <>
      {loading ? (
        <LoadingData />
      ) : (
        <>
          <div className='card mb-5 mb-xl-5'>
            <div className='card-body pt-5 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-0'>
                <div className='d-flex justify-content-between w-100'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <p className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1 mb-0'>
                          {data.nomClientSource ?? ''}
                        </p>
                        <span className='fw-bolder px-4 badge badge-light-primary'>
                          {data.source ?? ''}
                        </span>
                      </div>
                      <span className='d-flex align-items-center fw-bold fs-6 pe-2 text-gray-400 text-hover-primary me-5 mb-2'>
                        SIREN : {data.siren ?? ''}
                      </span>
                      <div className='d-flex flex-wrap fw-bold fs-6 mb-2 pe-2'>
                        <a
                          href={`https://www.google.com/maps/search/query=${toGmapQuery(
                            data.paysSource + ' ' + data.codePostalSource + ' ' + data.villeSource
                          )}`}
                          target={'_blank'}
                          className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                        >
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {data.paysSource}, {data.codePostalSource} {data.villeSource}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex overflow-auto justify-content-evenly h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR FICHE') && (
                    <li className='nav-item'>
                      <Link
                        className={
                          `nav-link text-active-primary me-6 ` +
                          (location.pathname === `/vente/client-sources/${clientId}/afficher` &&
                            'active')
                        }
                        to={`/vente/client-sources/${clientId}/afficher`}
                      >
                        Etablissement
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {ClientSourcesShowPage}
